var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OperationMould',{attrs:{"opId":_vm.opId,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }